var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex all:gap-[1.6rem] md:gap-[1.9rem]",class:_vm.classes},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }